
module dg.lists {

    //export interface IQuerySortCriteria {
    //    fieldId: string;
    //    displayValue: string;
    //    isAscending: boolean;
    //}

    class SortActionListController {

        public sortProperty: string;
        public sortPropertyDisplayValue: string;
        public sortFieldId: string;
        public isAscending: boolean;

        public sortFields: Array<any>;

        private queryManipulator: dg.actions.ServerQueryManipulator;

        $onInit = () => {
            this.sortProperty = this.queryManipulator.sortCriteria.property;
            this.sortPropertyDisplayValue = this.queryManipulator.sortCriteria.displayValue;
            this.isAscending = this.queryManipulator.sortCriteria.direction == 'asc' ? true : false;

            this.sortFields = this.queryManipulator.sortFields;
        }

        public selectOrderField = (sortableField) => {
            this.sortProperty = sortableField.id;
            this.sortPropertyDisplayValue = sortableField.displayValue;
            this.sort();
        }

        public sort = () => {
            let direction = this.isAscending ? 'asc' : 'desc';

            this.queryManipulator.sort({
                direction: direction,
                property: this.sortProperty,
                displayValue: this.sortPropertyDisplayValue
            });
        }
    }

    angular.module('dg.lists').component('sortActionList', {
        bindings: {
            options: '<',
            queryManipulator: '<'
        },
        controller: SortActionListController,
        templateUrl: '/digmo/src/lists/sort-action-list.html'
    });
}